
import React, { useState, useEffect } from 'react';
import { HeaderAd, ContentAd, FooterAd } from './GoogleAd';

const AWSVPCGuide = () => {
  const [isDarkTheme, setIsDarkTheme] = useState(true);

  // Theme detection and management
  useEffect(() => {
    setIsDarkTheme(true); // Default to dark theme
  }, []);

  // Styles object (single source of truth)
  const styles = {
    vpcLabel: {
      fontWeight: 700,
      fontSize: '1.2rem',
      color: isDarkTheme ? '#fff' : '#222',
      marginBottom: '0.5rem',
    },
    internetGateway: {
      display: 'flex',
  flexDirection: 'column' as React.CSSProperties['flexDirection'],
      alignItems: 'center',
      marginBottom: '1rem',
    },
    publicSubnet: {
      display: 'flex',
  flexDirection: 'column' as React.CSSProperties['flexDirection'],
      alignItems: 'center',
      margin: '1rem 0',
      padding: '1rem',
      background: isDarkTheme ? '#222f3e' : '#e3f2fd',
      borderRadius: '10px',
    },
    componentBox: {
      borderRadius: '8px',
      padding: '0.7rem 1.2rem',
      fontWeight: 600,
      margin: '0.5rem 0',
      boxShadow: '0 2px 6px rgba(0,0,0,0.08)',
    },
    privateSubnet1: {
      display: 'flex',
  flexDirection: 'column' as React.CSSProperties['flexDirection'],
      alignItems: 'center',
      margin: '1rem 0',
      padding: '1rem',
      background: isDarkTheme ? '#2d3436' : '#fbeee6',
      borderRadius: '10px',
    },
    privateSubnet2: {
      display: 'flex',
  flexDirection: 'column' as React.CSSProperties['flexDirection'],
      alignItems: 'center',
      margin: '1rem 0',
      padding: '1rem',
      background: isDarkTheme ? '#2d3436' : '#e8eaf6',
      borderRadius: '10px',
    },
    backToTop: {
  position: 'fixed' as React.CSSProperties['position'],
      bottom: '2rem',
      right: '2rem',
      background: isDarkTheme ? '#1976d2' : '#90caf9',
      color: isDarkTheme ? '#fff' : '#222',
      border: 'none',
      borderRadius: '50%',
      width: '48px',
      height: '48px',
      fontSize: '1.5rem',
      cursor: 'pointer',
      boxShadow: '0 2px 8px rgba(0,0,0,0.18)',
      zIndex: 1000,
      transition: 'background 0.3s, color 0.3s',
    },
    gatewayBox: {
      background: 'linear-gradient(135deg, #ff6b9d, #c44569)',
      color: 'white',
      padding: '0.8rem 1.5rem',
      borderRadius: '10px',
      fontWeight: 'bold',
      boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
    },
    h1: {
      fontSize: '2.2rem',
      fontWeight: 700,
      margin: '0.5rem 0 0.5rem 0',
      color: isDarkTheme ? '#90caf9' : '#1976d2',
  textAlign: 'center' as React.CSSProperties['textAlign'],
    },
    h2: {
      fontSize: '1.5rem',
      fontWeight: 600,
      margin: '1.5rem 0 1rem 0',
      color: isDarkTheme ? '#90caf9' : '#1976d2',
  textAlign: 'center' as React.CSSProperties['textAlign'],
    },
    h3: {
      fontSize: '1.2rem',
      fontWeight: 600,
      margin: '1.2rem 0 0.7rem 0',
      color: isDarkTheme ? '#b2dfdb' : '#1976d2',
    },
    h4: {
      fontSize: '1.05rem',
      fontWeight: 600,
      margin: '0.5rem 0 0.2rem 0',
      color: isDarkTheme ? '#fff' : '#333',
    },
    conceptGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
      gap: '1.5rem',
      margin: '1.5rem 0',
    },
    routeGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
      gap: '2rem',
      margin: '1.5rem 0',
    },
    routeTable: {
      background: isDarkTheme ? '#333333' : '#ffffff',
      border: isDarkTheme ? '2px solid #4da6ff' : '2px solid #3498db',
      borderRadius: '10px',
      padding: '1.5rem',
      boxShadow: isDarkTheme ? '0 4px 8px rgba(0,0,0,0.2)' : '0 4px 8px rgba(0,0,0,0.1)',
    },
    technicalSection: {
      background: isDarkTheme ? '#23272f' : '#f8fafc',
    },
    container: {
      minHeight: '100vh',
      background: isDarkTheme ? '#181a20' : '#f4f7fa',
      color: isDarkTheme ? '#fff' : '#222',
      transition: 'background 0.3s, color 0.3s',
    },
    contentContainer: {
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '2rem',
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '2rem',
    },
    themeToggle: {
      background: isDarkTheme ? '#222' : '#e3f2fd',
      color: isDarkTheme ? '#fff' : '#1976d2',
      border: 'none',
      borderRadius: '20px',
      padding: '0.5rem 1.2rem',
      cursor: 'pointer',
      fontWeight: 600,
      fontSize: '1rem',
      boxShadow: '0 2px 6px rgba(0,0,0,0.08)',
      transition: 'background 0.3s, color 0.3s',
    },
    nav: {
      display: 'flex',
      justifyContent: 'center',
      marginBottom: '2rem',
    },
    navList: {
      display: 'flex',
      gap: '1.5rem',
      listStyle: 'none',
      padding: 0,
      margin: 0,
    },
    navLink: {
      color: isDarkTheme ? '#90caf9' : '#1976d2',
      textDecoration: 'none',
      fontWeight: 600,
      fontSize: '1.1rem',
      cursor: 'pointer',
      padding: '0.3rem 0.8rem',
      borderRadius: '8px',
      transition: 'background 0.2s',
    },
    main: {
      marginTop: '2rem',
    },
    section: {
      marginBottom: '2.5rem',
      padding: '1.5rem',
      borderRadius: '12px',
      background: isDarkTheme ? '#23272f' : '#f8fafc',
      boxShadow: isDarkTheme ? '0 2px 8px rgba(0,0,0,0.18)' : '0 2px 8px rgba(0,0,0,0.08)',
    },
    analogySection: {
      background: isDarkTheme ? '#2d2f36' : '#fffbe7',
    },
    conceptCard: {
      background: isDarkTheme ? '#23272f' : '#fff',
      border: isDarkTheme ? '1px solid #444' : '1px solid #e0e0e0',
      borderRadius: '10px',
      padding: '1.2rem',
      boxShadow: isDarkTheme ? '0 2px 6px rgba(0,0,0,0.18)' : '0 2px 6px rgba(0,0,0,0.08)',
      marginBottom: '1.2rem',
    },
    vpcContainer: {
  display: 'flex',
  flexDirection: 'column' as React.CSSProperties['flexDirection'],
      alignItems: 'center',
      gap: '1.5rem',
      marginTop: '2rem',
    },
  };

  // Handler functions
  const toggleTheme = () => {
    setIsDarkTheme((prev) => !prev);
  };

  const scrollToSection = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div style={styles.container}>
      <div style={styles.contentContainer}>
        <header style={styles.header}>
          <button 
            style={styles.themeToggle}
            onClick={toggleTheme}
            onMouseEnter={(e) => {
              const target = e.currentTarget as HTMLButtonElement;
              target.style.background = '#ffffff';
              target.style.color = isDarkTheme ? '#e0e0e0' : '#333333';
            }}
            onMouseLeave={(e) => {
              const target = e.currentTarget as HTMLButtonElement;
              target.style.background = 'transparent';
              target.style.color = '#ffffff';
            }}
          >
            <span>{isDarkTheme ? '☀️' : '🌙'}</span>
            <span>{isDarkTheme ? 'Light' : 'Dark'}</span>
          </button>
          <h1 style={styles.h1}>🏗️ AWS VPC Complete Guide</h1>
          <p style={{ fontSize: '1.2rem', opacity: 0.9, margin: 0 }}>
            Understanding Virtual Private Cloud through Analogies and Technical Concepts
          </p>
        </header>

        {/* Header Advertisement */}
        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 2rem' }}>
          <HeaderAd isDarkTheme={isDarkTheme} />
        </div>

        {/* DevOps Interview Q&A Link */}
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <a
            href="/devops-interview-qa"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '0.5rem',
              padding: '0.75rem 1.5rem',
              borderRadius: '0.5rem',
              background: isDarkTheme 
                ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' 
                : 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
              color: 'white',
              textDecoration: 'none',
              fontWeight: 600,
              fontSize: '1rem',
              transition: 'transform 0.2s, box-shadow 0.2s',
              boxShadow: '0 4px 15px rgba(0,0,0,0.2)'
            }}
            onMouseEnter={(e) => {
              const target = e.currentTarget as HTMLAnchorElement;
              target.style.transform = 'translateY(-2px) scale(1.02)';
              target.style.boxShadow = '0 6px 20px rgba(0,0,0,0.3)';
            }}
            onMouseLeave={(e) => {
              const target = e.currentTarget as HTMLAnchorElement;
              target.style.transform = 'translateY(0) scale(1)';
              target.style.boxShadow = '0 4px 15px rgba(0,0,0,0.2)';
            }}
          >
            📚 DevOps Interview Q&A Guide
          </a>
        </div>

        {/* DevOps Tools Link */}
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <a
            href="/devops-tools"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '0.5rem',
              padding: '0.75rem 1.5rem',
              borderRadius: '0.5rem',
              background: isDarkTheme 
                ? 'linear-gradient(135deg, #10b981 0%, #059669 100%)' 
                : 'linear-gradient(135deg, #34d399 0%, #10b981 100%)',
              color: 'white',
              textDecoration: 'none',
              fontWeight: 600,
              fontSize: '1rem',
              transition: 'transform 0.2s, box-shadow 0.2s',
              boxShadow: '0 4px 15px rgba(0,0,0,0.2)'
            }}
            onMouseEnter={(e) => {
              const target = e.currentTarget as HTMLAnchorElement;
              target.style.transform = 'translateY(-2px) scale(1.02)';
              target.style.boxShadow = '0 6px 20px rgba(0,0,0,0.3)';
            }}
            onMouseLeave={(e) => {
              const target = e.currentTarget as HTMLAnchorElement;
              target.style.transform = 'translateY(0) scale(1)';
              target.style.boxShadow = '0 4px 15px rgba(0,0,0,0.2)';
            }}
          >
            🛠️ DevOps Tools & Setup Guide
          </a>
        </div>

        {/* VLSM Calculator Link */}
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <a
            href="/vlsm-calculator"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '0.5rem',
              padding: '0.75rem 1.5rem',
              borderRadius: '0.5rem',
              background: isDarkTheme 
                ? 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)' 
                : 'linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%)',
              color: 'white',
              textDecoration: 'none',
              fontWeight: 600,
              fontSize: '1rem',
              transition: 'transform 0.2s, box-shadow 0.2s',
              boxShadow: '0 4px 15px rgba(0,0,0,0.2)'
            }}
            onMouseEnter={(e) => {
              const target = e.currentTarget as HTMLAnchorElement;
              target.style.transform = 'translateY(-2px) scale(1.02)';
              target.style.boxShadow = '0 6px 20px rgba(0,0,0,0.3)';
            }}
            onMouseLeave={(e) => {
              const target = e.currentTarget as HTMLAnchorElement;
              target.style.transform = 'translateY(0) scale(1)';
              target.style.boxShadow = '0 4px 15px rgba(0,0,0,0.2)';
            }}
          >
            🧮 VLSM CIDR Calculator
          </a>
        </div>

        {/* AWS Regions & AZs Link */}
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <a
            href="/aws-regions-azs"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '0.5rem',
              padding: '0.75rem 1.5rem',
              borderRadius: '0.5rem',
              background: isDarkTheme 
                ? 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)' 
                : 'linear-gradient(135deg, #a78bfa 0%, #8b5cf6 100%)',
              color: 'white',
              textDecoration: 'none',
              fontWeight: 600,
              fontSize: '1rem',
              transition: 'transform 0.2s, box-shadow 0.2s',
              boxShadow: '0 4px 15px rgba(0,0,0,0.2)'
            }}
            onMouseEnter={(e) => {
              const target = e.currentTarget as HTMLAnchorElement;
              target.style.transform = 'translateY(-2px) scale(1.02)';
              target.style.boxShadow = '0 6px 20px rgba(0,0,0,0.3)';
            }}
            onMouseLeave={(e) => {
              const target = e.currentTarget as HTMLAnchorElement;
              target.style.transform = 'translateY(0) scale(1)';
              target.style.boxShadow = '0 4px 15px rgba(0,0,0,0.2)';
            }}
          >
            🌍 AWS Regions & Availability Zones Guide
          </a>
        </div>

        <nav style={styles.nav}>
          <ul style={styles.navList}>
            {[
              { id: 'analogies', label: '📚 Analogies' },
              { id: 'technical', label: '⚙️ Technical Concepts' },
              { id: 'routing', label: '🗺️ Route Tables' },
              { id: 'examples', label: '💡 Examples' },
              { id: 'architecture', label: '🏛️ Architecture' },
            ].map(item => (
              <li key={item.id}>
                <a 
                  style={styles.navLink}
                  onClick={() => scrollToSection(item.id)}
                  onMouseEnter={(e) => {
                    const target = e.currentTarget as HTMLAnchorElement;
                    target.style.background = isDarkTheme ? '#4da6ff' : '#007bff';
                    target.style.color = '#ffffff';
                    target.style.transform = 'translateY(-2px)';
                  }}
                  onMouseLeave={(e) => {
                    const target = e.currentTarget as HTMLAnchorElement;
                    target.style.background = 'transparent';
                    target.style.color = isDarkTheme ? '#b0b0b0' : '#495057';
                    target.style.transform = 'translateY(0)';
                  }}
                >
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        <main style={styles.main}>
          {/* Analogies Section */}
          <section id="analogies" style={{...styles.section, ...styles.analogySection}}>
            <h2 style={styles.h2}>📚 Understanding Through Analogies</h2>
            
            <h3 style={styles.h3}>🏢 Analogy 1: Gated Community/Office Building</h3>
            <div style={styles.conceptGrid}>
              {[
                { title: '🏢 VPC = Gated Community', desc: 'Your VPC is like a private gated community that you own. It\'s completely isolated from other communities, with its own address space, and you control who gets in and out.' },
                { title: '� Internet Gateway = Main Gate/Bridge', desc: 'The single point of entry/exit to the outside world (internet). It\'s like a drawbridge that can translate between your internal community addresses and external street addresses.' },
                { title: '�🏠 Subnets = Floors/Neighborhoods', desc: 'Public subnets = Ground floor with direct access to main gate\nPrivate subnets = Upper floors requiring internal transport (elevator/NAT)' },
                { title: '🗺️ Route Tables = Building Directory', desc: 'They tell traffic "To reach the internet, go through the main lobby exit" or "To reach another floor, use the internal elevator"' },
                { title: '👮 Security Groups = Personal Bodyguards', desc: 'Stateful protection that follows each person (EC2 instance) everywhere. If they let someone approach you, they automatically let them leave.' },
                { title: '🚪 NACLs = Security Checkpoints', desc: 'Stateless airport-style security at subnet entrances. They check everyone coming AND going separately.' },
                { title: '🎩 NAT Gateway = Reception Desk', desc: 'Private residents give requests to the concierge who goes out on their behalf. The outside world only sees the concierge.' },
              ].map((item, index) => (
                <div 
                  key={index} 
                  style={styles.conceptCard}
                  onMouseEnter={(e) => {
                    const target = e.currentTarget as HTMLDivElement;
                    target.style.transform = 'translateY(-5px)';
                    target.style.boxShadow = isDarkTheme ? '0 6px 12px rgba(0,0,0,0.4)' : '0 6px 12px rgba(0,0,0,0.15)';
                  }}
                  onMouseLeave={(e) => {
                    const target = e.currentTarget as HTMLDivElement;
                    target.style.transform = 'translateY(0)';
                    target.style.boxShadow = isDarkTheme ? '0 2px 4px rgba(0,0,0,0.2)' : '0 2px 4px rgba(0,0,0,0.1)';
                  }}
                >
                  <h4 style={styles.h4}>{item.title}</h4>
                  <p style={{ whiteSpace: 'pre-line' }}>{item.desc}</p>
                </div>
              ))}
            </div>

            <h3 style={styles.h3}>🚗 Analogy 2: Multi-Level Parking Complex</h3>
            <div style={styles.conceptGrid}>
              {[
                { title: '🏢 VPC = Parking Complex', desc: 'A large enclosed facility with defined boundaries, its own address system, and controlled access points.' },
                { title: '� Internet Gateway = Main Exit Booth', desc: 'The single automated exit gate that validates tickets and handles payment. It knows how to translate internal parking spot numbers to external street navigation.' },
                { title: '�🅿️ Subnets = Parking Sections', desc: 'Public subnets = Street-level sections with direct access to main exit\nPrivate subnets = Underground sections needing valet service (NAT)' },
                { title: '🚦 Route Tables = Traffic Signs', desc: 'Directional signs and painted arrows: "To exit → main gate", "To Level 2 → ramp B"' },
                { title: '🚨 Security Groups = Car Alarms', desc: 'Each car has its own security system. Stateful - unlock to get in, automatically lets you get out.' },
                { title: '🚧 NACLs = Section Barriers', desc: 'Physical gate arms between sections. Stateless - show pass both coming and going.' },
                { title: '🤵 NAT Gateway = Valet Service', desc: 'Cars in private sections can\'t reach the street directly. Valet drives your car out to run errands.' },
              ].map((item, index) => (
                <div 
                  key={index} 
                  style={styles.conceptCard}
                  onMouseEnter={(e) => {
                    const target = e.currentTarget as HTMLDivElement;
                    target.style.transform = 'translateY(-5px)';
                    target.style.boxShadow = isDarkTheme ? '0 6px 12px rgba(0,0,0,0.4)' : '0 6px 12px rgba(0,0,0,0.15)';
                  }}
                  onMouseLeave={(e) => {
                    const target = e.currentTarget as HTMLDivElement;
                    target.style.transform = 'translateY(0)';
                    target.style.boxShadow = isDarkTheme ? '0 2px 4px rgba(0,0,0,0.2)' : '0 2px 4px rgba(0,0,0,0.1)';
                  }}
                >
                  <h4 style={styles.h4}>{item.title}</h4>
                  <p style={{ whiteSpace: 'pre-line' }}>{item.desc}</p>
                </div>
              ))}
            </div>
          </section>

          {/* Technical Concepts Section */}
          <section id="technical" style={{...styles.section, ...styles.technicalSection}}>
            <h2 style={styles.h2}>⚙️ Technical Concepts</h2>
            
            <h3 style={styles.h3}>🌐 Virtual Private Cloud (VPC)</h3>
            <p>A VPC is an <strong>isolated virtual network</strong> within AWS that you define. It's your own private section of the AWS cloud.</p>
            <ul>
              <li><strong>IP address range (CIDR block)</strong> - defines total address space (e.g., 10.0.0.0/16)</li>
              <li><strong>Region-specific</strong> - spans all availability zones in a region</li>
              <li><strong>Complete isolation</strong> from other VPCs by default</li>
              <li><strong>Software-defined networking</strong> - you control routing, security, and connectivity</li>
            </ul>

            <h3 style={styles.h3}>🏠 Subnets</h3>
            <p>Subnets are <strong>subdivisions of your VPC</strong> that exist within a single Availability Zone.</p>
            
            <div style={styles.conceptGrid}>
              {[
                { title: '🌐 Public Subnet', desc: 'Has a route to an Internet Gateway, instances can have public IPs' },
                { title: '🔒 Private Subnet', desc: 'No direct internet access, instances only have private IPs' },
                { title: '🗄️ Database Subnet', desc: 'Typically private subnets in multiple AZs for database deployment' },
              ].map((item, index) => (
                <div key={index} style={styles.conceptCard}>
                  <h4 style={styles.h4}>{item.title}</h4>
                  <p>{item.desc}</p>
                </div>
              ))}
            </div>

            <h3 style={styles.h3}>🌍 Internet Gateway (IGW)</h3>
            <p>An Internet Gateway is a <strong>horizontally scaled, redundant, and highly available VPC component</strong> that allows communication between your VPC and the internet.</p>
            
            <div style={styles.conceptGrid}>
              {[
                { title: '🎯 Purpose', desc: 'Provides a target in your VPC route tables for internet-routable traffic\nPerforms network address translation (NAT) for instances with public IPv4 addresses' },
                { title: '📊 Characteristics', desc: 'Horizontally scaled and redundant\nNo availability risks or bandwidth constraints\nSupports IPv4 and IPv6 traffic\nOne IGW per VPC (1:1 relationship)' },
                { title: '🔄 How it Works', desc: 'Maps public IP addresses to private IP addresses\nOutbound: Private IP → Public IP\nInbound: Public IP → Private IP\nStateless - no connection tracking' },
                { title: '⚙️ Requirements', desc: 'Must be attached to VPC\nRoute table must have route to IGW (0.0.0.0/0)\nInstance must have public IP or Elastic IP\nSecurity groups must allow traffic' },
              ].map((item, index) => (
                <div key={index} style={styles.conceptCard}>
                  <h4 style={styles.h4}>{item.title}</h4>
                  <p style={{ whiteSpace: 'pre-line' }}>{item.desc}</p>
                </div>
              ))}
            </div>

            <div style={{
              background: isDarkTheme ? '#1e3a5f' : '#e3f2fd',
              border: isDarkTheme ? '1px solid #3498db' : '1px solid #2196f3',
              padding: '1.5rem',
              borderRadius: '10px',
              margin: '1.5rem 0',
            }}>
              <h4 style={{ ...styles.h4, color: isDarkTheme ? '#74b9ff' : '#1976d2', marginBottom: '1rem' }}>
                🔍 Deep Dive: Internet Gateway vs NAT Gateway
              </h4>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '2rem', marginBottom: '1rem' }}>
                <div>
                  <h5 style={{ color: isDarkTheme ? '#a8dadc' : '#2c5aa0', marginBottom: '0.5rem' }}>🌍 Internet Gateway</h5>
                  <ul style={{ color: isDarkTheme ? '#f1faee' : '#457b9d', lineHeight: 1.6 }}>
                    <li>Bidirectional internet access</li>
                    <li>For public subnets</li>
                    <li>Direct communication possible</li>
                    <li>No managed service charges</li>
                    <li>Stateless operation</li>
                  </ul>
                </div>
                <div>
                  <h5 style={{ color: isDarkTheme ? '#a8dadc' : '#2c5aa0', marginBottom: '0.5rem' }}>🎩 NAT Gateway</h5>
                  <ul style={{ color: isDarkTheme ? '#f1faee' : '#457b9d', lineHeight: 1.6 }}>
                    <li>Outbound-only internet access</li>
                    <li>For private subnets</li>
                    <li>No inbound connections allowed</li>
                    <li>Managed service with hourly charges</li>
                    <li>Stateful operation</li>
                  </ul>
                </div>
              </div>
              
              <div style={{ 
                background: isDarkTheme ? '#264653' : '#f8f9fa', 
                padding: '1rem', 
                borderRadius: '8px',
                marginTop: '1rem'
              }}>
                <strong style={{ color: isDarkTheme ? '#2a9d8f' : '#e76f51' }}>🎯 Key Point:</strong>
                <span style={{ color: isDarkTheme ? '#f1faee' : '#264653' }}>
                  {' '}Internet Gateway enables <strong>two-way</strong> internet communication for public subnets, 
                  while NAT Gateway provides <strong>one-way outbound</strong> internet access for private subnets.
                </span>
              </div>

              <div style={{ marginTop: '1.5rem', borderTop: isDarkTheme ? '1px solid #4a5568' : '1px solid #e2e8f0', paddingTop: '1rem' }}>
                <h5 style={{ color: isDarkTheme ? '#63b3ed' : '#2b6cb0', marginBottom: '0.75rem' }}>📖 AWS Documentation Links:</h5>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem' }}>
                  <a 
                    href="https://docs.aws.amazon.com/vpc/latest/userguide/VPC_Internet_Gateway.html"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ 
                      color: '#3498db', 
                      textDecoration: 'none',
                      fontWeight: '600',
                      fontSize: '14px',
                      padding: '0.5rem 1rem',
                      background: isDarkTheme ? '#2d3748' : '#f7fafc',
                      borderRadius: '6px',
                      border: isDarkTheme ? '1px solid #4a5568' : '1px solid #cbd5e0'
                    }}
                  >
                    📖 Internet Gateways Guide →
                  </a>
                  <a 
                    href="https://docs.aws.amazon.com/vpc/latest/userguide/VPC_Route_Tables.html"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ 
                      color: '#3498db', 
                      textDecoration: 'none',
                      fontWeight: '600',
                      fontSize: '14px',
                      padding: '0.5rem 1rem',
                      background: isDarkTheme ? '#2d3748' : '#f7fafc',
                      borderRadius: '6px',
                      border: isDarkTheme ? '1px solid #4a5568' : '1px solid #cbd5e0'
                    }}
                  >
                    📖 Route Tables Guide →
                  </a>
                </div>
              </div>
            </div>
          </section>

          {/* Route Tables Section */}
          <section id="routing" style={styles.section}>
            <h2 style={styles.h2}>🗺️ Route Tables - Destinations and Targets</h2>
            
            <h3 style={styles.h3}>🎯 Understanding Destinations and Targets</h3>
            <p>Think of route tables like asking for directions:</p>
            <ul>
              <li><strong>Destination (CIDR)</strong> = "I want to go to WHERE?" (IP address range)</li>
              <li><strong>Target</strong> = "Use WHAT interface to get there?" (gateway/interface)</li>
            </ul>

            <h3 style={styles.h3}>🌍 Internet Gateway Route Configuration</h3>
            <div style={{
              background: isDarkTheme ? '#2d3748' : '#f7fafc',
              padding: '1.5rem',
              borderRadius: '10px',
              border: isDarkTheme ? '2px solid #4299e1' : '2px solid #3182ce',
              margin: '1rem 0'
            }}>
              <h4 style={{ ...styles.h4, color: isDarkTheme ? '#63b3ed' : '#2b6cb0', marginBottom: '1rem' }}>
                🎯 Making a Subnet "Public" with Internet Gateway
              </h4>
              
              <div style={{ marginBottom: '1.5rem' }}>
                <h5 style={{ color: isDarkTheme ? '#a0aec0' : '#4a5568', marginBottom: '0.5rem' }}>Step-by-Step Process:</h5>
                <ol style={{ color: isDarkTheme ? '#e2e8f0' : '#2d3748', lineHeight: 1.8 }}>
                  <li><strong>Create Internet Gateway:</strong> One per VPC, highly available by design</li>
                  <li><strong>Attach to VPC:</strong> IGW must be attached to your VPC to function</li>
                  <li><strong>Create Route Table:</strong> Or modify existing subnet route table</li>
                  <li><strong>Add Route:</strong> Destination <code>0.0.0.0/0</code> → Target <code>Internet Gateway</code></li>
                  <li><strong>Associate Subnet:</strong> Link the route table to your desired subnet</li>
                  <li><strong>Assign Public IPs:</strong> Instances need public IP or Elastic IP</li>
                </ol>
              </div>

              <div style={{
                background: isDarkTheme ? '#1a202c' : '#edf2f7',
                padding: '1rem',
                borderRadius: '8px',
                fontFamily: 'monospace',
                fontSize: '0.9rem'
              }}>
                <div style={{ color: isDarkTheme ? '#68d391' : '#38a169', fontWeight: 'bold', marginBottom: '0.5rem' }}>
                  📋 Example Route Table Entry:
                </div>
                <div style={{ color: isDarkTheme ? '#f7fafc' : '#1a202c' }}>
                  Destination: <span style={{ background: isDarkTheme ? '#4a5568' : '#cbd5e0', padding: '2px 6px', borderRadius: '4px' }}>0.0.0.0/0</span> 
                  {' → '}Target: <span style={{ background: isDarkTheme ? '#4a5568' : '#cbd5e0', padding: '2px 6px', borderRadius: '4px' }}>igw-1234567890abcdef0</span>
                </div>
                <div style={{ color: isDarkTheme ? '#a0aec0' : '#718096', fontSize: '0.8rem', marginTop: '0.5rem', fontStyle: 'italic' }}>
                  This means: "All traffic to any internet destination (0.0.0.0/0) should go through this Internet Gateway"
                </div>
              </div>
            </div>

            <h3 style={styles.h3}>📍 How Route Matching Works</h3>
            <ol>
              <li><strong>Look at destination IP</strong> of outgoing packet</li>
              <li><strong>Find all routes</strong> whose destination CIDR contains that IP</li>
              <li><strong>Choose most specific match</strong> (longest prefix)</li>
              <li><strong>Forward traffic</strong> to that route's target</li>
            </ol>

            <div style={styles.routeGrid}>
              <div style={styles.routeTable}>
                <h4 style={styles.h4}>🌐 Public Subnet Routes</h4>
                <div style={{ margin: '0.8rem 0', padding: '0.5rem', background: isDarkTheme ? '#2d2d2d' : '#f8f9fa', borderRadius: '5px' }}>
                  10.0.0.0/16 → Local (VPC Internal)
                </div>
                <div style={{ margin: '0.8rem 0', padding: '0.5rem', background: isDarkTheme ? '#2d2d2d' : '#f8f9fa', borderRadius: '5px' }}>
                  0.0.0.0/0 → Internet Gateway
                </div>
              </div>
              
              <div style={styles.routeTable}>
                <h4 style={styles.h4}>🔒 Private Subnet Routes</h4>
                <div style={{ margin: '0.8rem 0', padding: '0.5rem', background: isDarkTheme ? '#2d2d2d' : '#f8f9fa', borderRadius: '5px' }}>
                  10.0.0.0/16 → Local (VPC Internal)
                </div>
                <div style={{ margin: '0.8rem 0', padding: '0.5rem', background: isDarkTheme ? '#2d2d2d' : '#f8f9fa', borderRadius: '5px' }}>
                  0.0.0.0/0 → NAT Gateway
                </div>
              </div>
            </div>
          </section>

          {/* Content Advertisement */}
          <div style={{ maxWidth: '1200px', margin: '2rem auto', padding: '0 2rem' }}>
            <ContentAd isDarkTheme={isDarkTheme} />
          </div>

          {/* Examples Section */}
          <section id="examples" style={styles.section}>
            <h2 style={styles.h2}>💡 Real-World Examples</h2>

            <h3 style={styles.h3}>🌐 Public Subnet with Internet Gateway - Complete Flow</h3>
            <div style={{
              background: isDarkTheme ? '#2d3748' : '#f0fff4',
              padding: '1.5rem',
              borderRadius: '10px',
              border: isDarkTheme ? '2px solid #48bb78' : '2px solid #38a169',
              margin: '1rem 0'
            }}>
              <h4 style={{ color: isDarkTheme ? '#68d391' : '#2f855a', marginBottom: '1rem' }}>
                📤 Outbound Internet Request (EC2 → Internet)
              </h4>
              <ol style={{ color: isDarkTheme ? '#e2e8f0' : '#1a202c', lineHeight: 1.8 }}>
                <li><strong>EC2 Instance</strong> (10.0.1.100) wants to reach google.com (8.8.8.8)</li>
                <li><strong>Route Table Lookup:</strong> Finds route <code>0.0.0.0/0 → Internet Gateway</code></li>
                <li><strong>Security Group Check:</strong> Allows outbound HTTPS (port 443)</li>
                <li><strong>NACL Check:</strong> Allows outbound traffic (default allow-all)</li>
                <li><strong>Internet Gateway NAT:</strong> Maps private IP (10.0.1.100) to public IP (203.0.113.10)</li>
                <li><strong>Internet Routing:</strong> Packet sent to internet with source IP 203.0.113.10</li>
                <li><strong>Response Path:</strong> Google responds to 203.0.113.10</li>
                <li><strong>IGW Reverse NAT:</strong> Maps public IP back to private IP (10.0.1.100)</li>
                <li><strong>Delivery:</strong> Response delivered to EC2 instance</li>
              </ol>
              
              <div style={{
                background: isDarkTheme ? '#1a202c' : '#ffffff',
                padding: '1rem',
                borderRadius: '8px',
                marginTop: '1rem',
                fontFamily: 'monospace',
                fontSize: '0.85rem'
              }}>
                <div style={{ color: isDarkTheme ? '#fbb6ce' : '#d53f8c', marginBottom: '0.5rem' }}>📍 Address Translation:</div>
                <div style={{ color: isDarkTheme ? '#e2e8f0' : '#2d3748' }}>
                  Internal: <code>10.0.1.100:54321 → 8.8.8.8:443</code><br/>
                  External: <code>203.0.113.10:54321 → 8.8.8.8:443</code>
                </div>
              </div>
            </div>

            <h4 style={{ color: isDarkTheme ? '#63b3ed' : '#2b6cb0', marginBottom: '1rem' }}>
              📥 Inbound Internet Request (Internet → EC2)
            </h4>
            <div style={{
              background: isDarkTheme ? '#2d3748' : '#fffaf0',
              padding: '1.5rem',
              borderRadius: '10px',
              border: isDarkTheme ? '2px solid #ed8936' : '2px solid #dd6b20',
              margin: '1rem 0'
            }}>
              <ol style={{ color: isDarkTheme ? '#e2e8f0' : '#1a202c', lineHeight: 1.8 }}>
                <li><strong>External Client</strong> sends request to your public IP (203.0.113.10:80)</li>
                <li><strong>Internet Gateway</strong> receives the inbound packet</li>
                <li><strong>Address Translation:</strong> IGW maps public IP to private IP (10.0.1.100)</li>
                <li><strong>NACL Check:</strong> Allows inbound HTTP traffic (stateless - must be explicitly allowed)</li>
                <li><strong>Route to Subnet:</strong> Packet forwarded to private IP in correct subnet</li>
                <li><strong>Security Group Check:</strong> Must allow inbound HTTP (port 80) from 0.0.0.0/0</li>
                <li><strong>Delivery:</strong> Packet reaches EC2 instance on port 80</li>
                <li><strong>Response:</strong> Return path follows same process in reverse</li>
              </ol>
            </div>

            <h3 style={styles.h3}>🔒 Private Subnet Internet Access via NAT Gateway</h3>
            <ol>
              <li>EC2 instance in private subnet (private IP only)</li>
              <li>Route table has route: <code>0.0.0.0/0 → NAT Gateway</code></li>
              <li>NAT Gateway in public subnet forwards to Internet Gateway</li>
              <li>Return traffic follows same path in reverse</li>
            </ol>

            <div style={{
              background: isDarkTheme ? '#4a1810' : '#fed7d7',
              border: isDarkTheme ? '2px solid #fc8181' : '2px solid #e53e3e',
              padding: '1.5rem',
              borderRadius: '10px',
              margin: '1.5rem 0'
            }}>
              <h4 style={{ color: isDarkTheme ? '#fc8181' : '#c53030', marginBottom: '1rem' }}>
                ⚠️ Common Internet Gateway Mistakes
              </h4>
              <ul style={{ color: isDarkTheme ? '#fed7d7' : '#742a2a', lineHeight: 1.6 }}>
                <li><strong>Missing Route:</strong> Creating IGW but forgetting to add <code>0.0.0.0/0</code> route</li>
                <li><strong>Wrong Route Table:</strong> Adding route to default route table instead of subnet-specific one</li>
                <li><strong>No Public IP:</strong> Instance in public subnet but no public IP assigned</li>
                <li><strong>Security Groups:</strong> Blocking necessary ports (22 for SSH, 80/443 for web)</li>
                <li><strong>NACL Issues:</strong> Custom NACLs that block return traffic (remember: stateless!)</li>
                <li><strong>Multiple IGWs:</strong> Trying to attach multiple IGWs to one VPC (not allowed)</li>
              </ul>
            </div>
          </section>

          {/* Architecture Section */}
          <section id="architecture" style={styles.section}>
            <h2 style={styles.h2}>🏛️ Architecture</h2>

            <div style={styles.vpcContainer}>
              <div style={styles.vpcLabel}>🏢 VPC (10.0.0.0/16)</div>
              
              <div style={styles.internetGateway}>
                <div style={styles.gatewayBox}>🌍 Internet Gateway</div>
              </div>

              <div style={styles.publicSubnet}>
                <div style={{ fontWeight: 'bold', marginBottom: '1rem', color: '#333', fontSize: '0.9rem' }}>
                  🌐 Public Subnet (10.0.1.0/24) - AZ-a
                </div>
                <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
                  <div style={{...styles.componentBox, background: 'linear-gradient(135deg, #74b9ff, #0984e3)', color: 'white'}}>
                    🔄 NAT Gateway
                  </div>
                  <div style={{...styles.componentBox, background: 'linear-gradient(135deg, #55a3ff, #3742fa)', color: 'white'}}>
                    🖥️ Web Server<br/>
                    <small>203.0.113.10</small>
                  </div>
                </div>
              </div>

              <div style={styles.privateSubnet1}>
                <div style={{ fontWeight: 'bold', marginBottom: '1rem', color: '#333', fontSize: '0.9rem' }}>
                  🔒 Private Subnet (10.0.2.0/24) - AZ-a
                </div>
                <div style={{...styles.componentBox, background: 'linear-gradient(135deg, #ff7675, #d63031)', color: 'white'}}>
                  ⚙️ App Server<br/>
                  <small>10.0.2.20</small>
                </div>
              </div>

              <div style={styles.privateSubnet2}>
                <div style={{ fontWeight: 'bold', marginBottom: '1rem', color: '#333', fontSize: '0.9rem' }}>
                  🗄️ Private Subnet (10.0.3.0/24) - AZ-b
                </div>
                <div style={{...styles.componentBox, background: 'linear-gradient(135deg, #fd79a8, #e84393)', color: 'white'}}>
                  💾 Database Server<br/>
                  <small>10.0.3.50</small>
                </div>
              </div>
            </div>

            <h3 style={styles.h3}>🔑 Key Benefits</h3>
            <ul>
              <li><strong>Isolation</strong> - Your network is completely separate</li>
              <li><strong>Control</strong> - You define all routing and security rules</li>
              <li><strong>Scalability</strong> - Subnets can be added/removed as needed</li>
              <li><strong>Security</strong> - Multiple layers of access control</li>
              <li><strong>Flexibility</strong> - Support for complex network architectures</li>
            </ul>

            <div style={{
              background: isDarkTheme ? '#4a4a1a' : '#fff3cd',
              border: isDarkTheme ? '1px solid #fbbf24' : '1px solid #ffeaa7',
              padding: '1rem',
              borderRadius: '5px',
              margin: '1rem 0',
            }}>
              <strong>🎯 Key Takeaway:</strong><br/>
              <strong>Destination</strong> = IP range pattern to match against<br/>
              <strong>Target</strong> = Where to forward matching traffic<br/>
              <strong>Most specific route wins</strong> (longest prefix match)<br/>
              This gives you <strong>enterprise-grade networking</strong> in the cloud with complete control!
            </div>
          </section>
        </main>

        {/* Footer Advertisement */}
        <div style={{ maxWidth: '1200px', margin: '2rem auto', padding: '0 2rem' }}>
          <FooterAd isDarkTheme={isDarkTheme} />
        </div>

        <button 
          style={styles.backToTop}
          onClick={scrollToTop}
          onMouseEnter={(e) => {
            const target = e.currentTarget as HTMLButtonElement;
            target.style.background = isDarkTheme ? '#7db3e8' : '#0056b3';
            target.style.transform = 'translateY(-2px)';
          }}
          onMouseLeave={(e) => {
            const target = e.currentTarget as HTMLButtonElement;
            target.style.background = isDarkTheme ? '#4da6ff' : '#007bff';
            target.style.transform = 'translateY(0)';
          }}
        >
          ↑
        </button>
      </div>
    </div>
  );
};

export default AWSVPCGuide;